import PropTypes from 'prop-types';
import React from 'react';
import { stepType } from 'utils/reactFlowUtils';

import Flowchart from './flowchart';
import SelectionProvider from './selectionProvider';

export default function CollapsedFlowchartView({
  treesData,
  root,
  expandTo = undefined,
}) {
  return (
    <SelectionProvider root={root}>
      <Flowchart
        type="collapsed"
        treesData={treesData}
        root={root}
        expandTo={expandTo}
      />
    </SelectionProvider>
  );
}

CollapsedFlowchartView.propTypes = {
  treesData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.arrayOf(stepType),
    ),
  ).isRequired,
  root: stepType.isRequired,
  expandTo: PropTypes.func,
};
